<template>
  <div class="organization-access d-flex flex-column py-5 justify-content-center align-items-center" style="width:100%; min-height: 100vh" :style="{ backgroundColor: orgCode.includes('charter') ? '#F3F9FF' : '#E5E5E5' }">
    <div>
      <img v-if="orgCode.includes('charter')" src="../assets/images/logos/charter-logo.png"/>
      <img v-else src="../assets/images/logos/small-logo.png"/>
    </div>
      <h4 class="h5 my-4">
        <b>Hello, {{ currentUser.name }}. Welcome to
          <span v-if="orgCode.includes('charter')">Charter Communication</span
          ><span v-else>FastVisa</span>.</b>
      </h4>
      <h4 class="my-4">Please Select Organization that you want to access!</h4>
    <div class="d-flex w-100 align-items-start justify-content-center" style="column-gap: 1rem">
      <div class="access-card">
        <h5 class="font-weight-bold">Manage</h5>
        <p class="m-0 mt-3">Work on immigration cases efficiently and effectively. It provides a centralized hub where you can access all the necessary information and tools related to a specific case as a case conrtibutor.</p>
        <div class="access-org">
          <h6 class="font-weight-bold mt-3">Organizations</h6>
          <div class="d-flex flex-column" style="row-gap: 0.6rem">
            <div v-for="item in currentUser.organization_accesses_data" :key="item.organization_id" role="button" class="org-card p-2" @click="updateUserOrganization(item.organization_id)">
              <img src="../assets/images/icons/apartment.svg" class="p-0 mr-1" style="width: 30px"/>
              <span class="font-weight-bold m-0 w-100">
                {{ item.organization_name }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="institutionName" class="access-institution">
          <h6 class="font-weight-bold mt-3">Institution</h6>
          <div class="d-flex flex-column" style="row-gap: 0.6rem">
            <a href="/institutions" style="color: #3F3F3F">
              <div class="org-card p-2">
                <img src="../assets/images/icons/company.svg" class="p-0 mr-1" style="width: 30px"/>
                <span class="font-weight-bold m-0 w-100">
                  {{ institutionName }}
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: { },
  created() {},
  computed: {
    ...mapGetters([
      'currentUser', 'institutionName', 'organization'
    ]),
    orgCode(){
      return this.organization.org_code
    }
  },
  methods: {
    updateUserOrganization(id){
      let data={
        id: this.currentUser.id,
        organization_id: id,
      }
      this.$store.dispatch('updateUserOrganization',data).then(()=>{
        setTimeout(this.dashboardRedirect(), 5000);
      })
    },
    dashboardRedirect(){
      window.location.href = "/dashboard"
    },
    clearNotify(){
      setTimeout(() => {
        const notify = document.getElementById('notify');
        if(notify){
          notify.style.display = 'none';
        }
      }, 100)
    }
  },
  data: () => ({
    firstName: '',
    lastName: "",
    email: "",
    role: "",
    orgAccess: "",
    phoneNumber: "",
    email: "",
    address: "",
    organizations: "",
  }),
  mounted(){
    this.clearNotify();
  }
};
</script>

<style lang="scss">
.organization-access {
  .access-card {
    background-color: white;
    border-radius: 7px;
    border: 1px solid #d7d7d7;
    padding: 1.2rem;
    width: 30%;
  }

  .org-card {
    display: flex;
    align-items: center;
    justify-content: start;
    border-radius: 5px;
    border: 1px solid #d7d7d7;
    padding: 0.4rem;
  }
}
.org-button{
  background-color: white;
  border-radius: 5px;
  border: 2px;
  border-color: #BDBDBD;
}
</style>
